import { render, staticRenderFns } from "./LoginEmpresa.vue?vue&type=template&id=b315258c"
import script from "./LoginEmpresa.vue?vue&type=script&lang=js"
export * from "./LoginEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports